export const HamburgerIcon = ({ isOpen }: { isOpen: boolean }) => (
  <div className="relative flex h-[22px] w-[22px] flex-col items-center justify-center">
    <span
      className={`rounded-full h-[2px] w-[18px] bg-primary-10 transition-all duration-200 ${isOpen ? 'opacity-0' : ''}`}
    />
    <span
      className={`rounded-full my-[5px] h-[2px] w-[18px] bg-primary-10 transition-all duration-200 ${isOpen ? 'opacity-0' : ''}`}
    />
    <span
      className={`rounded-full h-[2px] w-[18px] bg-primary-10 transition-all duration-200 ${isOpen ? 'opacity-0' : ''}`}
    />
    <span
      className={`rounded-full absolute h-[2px] w-[18px] bg-primary-10 transition-all duration-200 ${isOpen ? 'visible rotate-45 opacity-100' : 'invisible opacity-0'}`}
    />
    <span
      className={`rounded-full absolute h-[2px] w-[18px] bg-primary-10 transition-all duration-200 ${isOpen ? 'visible rotate-[135deg] opacity-100' : 'invisible opacity-0'}`}
    />
  </div>
);
